import { InstructionBase, InstructionCategory } from './InstructionTypes';

export type ConditionInstruction = ConditionIfInstruction;

export enum ExecuteType {
  IN_SERIES = 'inSeries',
  IN_PARALLEL = 'inParallel'
}

interface ConditionIfInstruction extends InstructionBase {
  category: InstructionCategory.CONDITION,
  name: 'if',
  parameters: {
    conditions: {
      instructionType: 'if' | 'elseIf' | 'else';
      conditionExpression: string;
      execute: ExecuteType;
      sequenceName: string;
    }[];
  }
}
